import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import SplineApi from "../../tools/spline-api.js";

export interface TradePerformanceRow {
  cusip: string;
  issue_id: number;
  offering_date: string | null;
  offering_yield: number | null;
  offering_spread: number | null;
  maturity_date: string | null;
  total_maturity_offering_amt: number | null;
  trade_date: string;
  time_of_trade: string;
  traded_yield: number | null;
  traded_spread: number | null;
  par_traded: number;
  volume: number | null;
  acc_volume: number | null;
  trade_type_indicator: string;
  is_lp: boolean;
  is_markup: boolean;
}

export default function useTradeAnalysis() {
  const { getAccessTokenSilently } = useAuth0();
  const [rows, setRows] = useState<TradePerformanceRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTradePerformance = async (cusip: string) => {
    setLoading(true);
    setError(null);
    setRows([]);

    try {
      const token = await getAccessTokenSilently();
      const api = new SplineApi(token);
      const response = await api.getTradePerformance(cusip);
      setRows(response as TradePerformanceRow[]);
    } catch (e: any) {
      setError(e?.message || "Failed to fetch trade performance.");
    } finally {
      setLoading(false);
    }
  };

  return { fetchTradePerformance, rows, loading, error };
}
